import { TherapistAction } from '../../../src/redux/actions/constant';

export const getAllTherapistListAction = (payload: any) => {
    return {
        type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST,
        payload,
    };
};

export const getAllTherapistListResetAction = () => {
    return {
        type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_RESET,
    };
};

